import React from "react";
import { PricingPlans } from "@/components/PricingPlans";

export default function Pricing() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16">
      <div className="text-center">
        <div className="text-xs uppercase tracking-widest font-bold text-[#F59E0B]">Plans & Pricing</div>
        <h1 className="mt-2 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight text-[#1F2937]">Unlock the full academy</h1>
        <p className="mx-auto mt-3 max-w-2xl font-body text-base sm:text-lg text-[#6B7280]">
          Start free with a sample lesson in every subject. Upgrade any time to open the complete PreK–8 curriculum, progress reports and sticker rewards.
        </p>
      </div>
      <div className="mt-10">
        <PricingPlans />
      </div>
    </div>
  );
}
